module.exports = __webpack_public_path__ + "img/asrc.c497fa4.png";